/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response containing the results of participant notification attempts
 * @export
 * @interface NotifyParticipantsResponse
 */
export interface NotifyParticipantsResponse {
    /**
     * Total number of notification attempts made
     * @type {number}
     * @memberof NotifyParticipantsResponse
     */
    totalNotifications: number;
    /**
     * Number of notifications sent successfully
     * @type {number}
     * @memberof NotifyParticipantsResponse
     */
    successfulNotifications: number;
    /**
     * Number of notifications that failed
     * @type {number}
     * @memberof NotifyParticipantsResponse
     */
    failedNotifications: number;
    /**
     * The correlation UUID used to match API responses with websocket messages
     * @type {string}
     * @memberof NotifyParticipantsResponse
     */
    correlationUuid: string;
}

/**
 * Check if a given object implements the NotifyParticipantsResponse interface.
 */
export function instanceOfNotifyParticipantsResponse(value: object): value is NotifyParticipantsResponse {
    if (!('totalNotifications' in value) || value['totalNotifications'] === undefined) return false;
    if (!('successfulNotifications' in value) || value['successfulNotifications'] === undefined) return false;
    if (!('failedNotifications' in value) || value['failedNotifications'] === undefined) return false;
    if (!('correlationUuid' in value) || value['correlationUuid'] === undefined) return false;
    return true;
}

export function NotifyParticipantsResponseFromJSON(json: any): NotifyParticipantsResponse {
    return NotifyParticipantsResponseFromJSONTyped(json, false);
}

export function NotifyParticipantsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotifyParticipantsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalNotifications': json['total_notifications'],
        'successfulNotifications': json['successful_notifications'],
        'failedNotifications': json['failed_notifications'],
        'correlationUuid': json['correlation_uuid'],
    };
}

export function NotifyParticipantsResponseToJSON(json: any): NotifyParticipantsResponse {
    return NotifyParticipantsResponseToJSONTyped(json, false);
}

export function NotifyParticipantsResponseToJSONTyped(value?: NotifyParticipantsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total_notifications': value['totalNotifications'],
        'successful_notifications': value['successfulNotifications'],
        'failed_notifications': value['failedNotifications'],
        'correlation_uuid': value['correlationUuid'],
    };
}

